import type React from 'react';
import { Page as Component } from '~/components/specifics/deals/[id]/estimations/Page';

export const Page: React.FC = () => <Component />;
